import React, { useState } from "react";
import {
    Layout, Menu
} from "antd";
import {
    SearchOutlined, RobotOutlined, DiffOutlined,
    FileTextOutlined
} from '@ant-design/icons';
import '../CSS/style-guide.css'
import { useLocation, Link } from "react-router-dom";
import PowerBI from "../components/PowerBI";


const { Sider } = Layout;

// Navigation component with collapsible sidebar and menu items
// including internal links and an external link to Power BI reports
const Nav = () => {
    const [collapsed, setCollapsed] = useState(true);
    const location = useLocation();

    const powerBIAppUrl = "https://app.powerbi.com/groups/b92ead50-fa12-41d2-b5a7-f3d639acdde0/reports/89f86def-062b-497b-a98f-4d5969c91481/f550446bb0b54e599c16?language=en-US&experience=power-bi";

    // Navigation buttons with icons and labels
    // Each button has a key, icon, label, and path for routing
    const navbottons = [
        {
            key: "1",
            icon: <SearchOutlined />,
            label: <Link to="/ContractSearch">Search in Contracts</Link>,
            path: "/"
        },
        // {
        //     key: "2",
        //     icon: <DiffOutlined />,
        //     label: <Link to="/compare-contracts">Compare Contracts</Link>,
        //     path: "/compare-contracts"
        // },
        {
            key: "3",
            icon: <RobotOutlined />,
            label: <Link to="/copilot">SCIA Chat Agent</Link>,
            path: "/copilot"
        },
        {
            key: "4",
            icon: <FileTextOutlined />,
            // render as plain label and open externally in the Menu onClick handler
            label: <span>Reports</span>,
            path: powerBIAppUrl
        }
    ];

    // controlled selected key so we can keep it unchanged for external links
    const [selectedKey, setSelectedKey] = useState(
        navbottons.find(item => location.pathname === item.path)?.key || "1"
    );

    // update on route change
    React.useEffect(() => {
        const key = navbottons.find(item => location.pathname === item.path)?.key || "1";
        setSelectedKey(key);
    }, [location.pathname]);

    return (
        <div className="SCAUX">
                    <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} width={220} style={{ marginTop: "63px", height:"100vh"}}>
                        <div className="demo-logo-vertical" />
                        <Menu
                            theme="dark"
                            selectedKeys={[selectedKey]}
                            mode="inline"
                            items={navbottons}
                            style={{ marginTop: "10px" }}
                            onClick={({ key, domEvent }) => {
                                const clicked = navbottons.find(i => i.key === key);
                                if (!clicked) return;
                                // if external (http/https) open in new tab but keep current selection
                                if (typeof clicked.path === "string" && clicked.path.startsWith("http")) {
                                    // prevent any default navigation / page reload
                                    domEvent?.preventDefault();
                                    domEvent?.stopPropagation();
                                    window.open(clicked.path, "_blank", "noopener");
                                    return;
                                }
                                // otherwise update selection (internal navigation)
                                setSelectedKey(key);
                            }}
                        />
                    </Sider>
        </div>
    );
}

export default Nav;